import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../stores/store";
import { useEffect } from "react";
import { fetchCoupons } from "../../stores/slices/couponSlice";
import { fetchInfos } from "../../stores/slices/infoSlice";
import { fetchTopics } from "../../stores/slices/topicSlice";


const Home = () => {
  const dispatch = useDispatch<AppDispatch>();
  const couponData = useSelector((state: RootState) => state.coupons.coupons);
  const infoData = useSelector((state: RootState) => state.infos.infos);
  const topicData = useSelector((state: RootState) => state.topics.topics);
  
  useEffect(() => {
    dispatch(fetchCoupons());
    dispatch(fetchInfos());
    dispatch(fetchTopics());
  }, [dispatch]);

  const couponSpecialSum = couponData.filter(item => item.special === "1");

  return (
    <>
      <h2>各種データサマリー</h2>
      <div className="listSummary">
        <ul>
          <li>
            <div className="title">クーポン（全件）</div>
            <div className="data">{couponData.length}<span>件</span></div>
            <div className="link"><Link to="/coupon">クーポンを登録する</Link></div>
          </li>
          <li>
            <div className="title">会員限定クーポン（内）</div>
            <div className="data">{couponSpecialSum.length}<span>件</span></div>
            <div className="link"><Link to="/coupon">クーポンを登録する</Link></div>
          </li>
        </ul>
      </div>
      <div className="listSummary">
        <ul>
          <li>
            <div className="title">お知らせ</div>
            <div className="data">{infoData.length}<span>件</span></div>
            <div className="link"><Link to={"/info"}>お知らせを登録する</Link></div>
          </li>
          <li>
            <div className="title">トピクス</div>
            <div className="data">{topicData.length}<span>件</span></div>
            <div className="link"><Link to={"/topic"}>トピクスを登録する</Link></div>
          </li>
        </ul>
      </div>
      <div className="listSummary">
        <ul>
          <li>
            <div className="title">総ユーザー</div>
            <div className="data">5<span>人</span></div>
            <div className="link"><Link to={"/user"}>詳しく見る</Link></div>
          </li>
          <li>
            <div className="title">総ポイント</div>
            <div className="data">150<span>P</span></div>
            <div className="link"><Link to={"/point"}>詳しく見る</Link></div>
          </li>
        </ul>
      </div>
      <div className="listSummary">
        <ul>
          <li>
            <div className="title">広告 - 注文完了画面</div>
            <div className="data">2<span>件</span></div>
            <div className="link"><Link to={"/advertisement"}>掲載中の広告を確認する</Link></div>
          </li>
        </ul>
      </div>
    </>
  );
}
export default Home;